import {type FishGroup} from 'client';

export const resolveProperty = (fishgroups: FishGroup[] = [], property: string): string[] => [
  ...new Set(fishgroups?.map((fishGroup) => resolveKey(property, fishGroup)).filter((item) => item)),
];

const resolveKey = (key: string, obj: FishGroup, separator = '.'): string => {
  const properties = Array.isArray(key) ? key : key.split(separator);
  return properties.reduce((prev, curr) => prev?.[curr], obj);
};

export const mergeArrays = (array1: string[], array2: string[], separator = '|'): string[] =>
  array1.map((e, i) => `${e} ${separator} ${array2[i]}`);

export const siteCageOptions = (sites: string[], cages: string[]) => {
  if (sites.length > 1) {
    return sites;
  }
  if (cages.length > 1) {
    return cages;
  }
  return mergeArrays(sites, cages);
};
